import React, { Component } from "react";
import Icon from "../../pageElements/icon";
import "./links.css";

class Link extends Component {
  render() {
    return (
      <a
        id={this.props.id}
        tabIndex="0"
        className={this.props.link.title.substr(0, 3)}
        href={this.props.link.url}
        style={{
          listStyle: "none",
          display: "inline-block",
          width: "22%",
          maxHeight: "135px",
          height: (window.innerWidth / 5) * 0.56 + "px",
          margin: "1.5vw 1.5%",
          padding: "10px",
          textDecoration: "none",
          fontSize: "18px"
        }}
      >
        <li
          style={{
            display: "block",
            padding: "10px",
            height: "100%",
            position: "relative",
            fontWeight: 500,
            fontFamily: "Oswald, sans-serif",
            textTransform: "uppercase",
            margin: 0
          }}
        >
          {this.props.link.title}
          <Icon
            className={this.props.link.title.substr(0, 3)}
            type={this.props.link.title.substr(0, 3)}
          />
        </li>
      </a>
    );
  }
}

export default Link;
